import Joi from 'joi';

import { generateJoiValidation } from '@/shared/validations/generateJoiValidation';
import { Permissions } from '@/modules/permissions/permissions.model';
import { objectId } from '@/shared/validations/custom.validation';

export const createPermissions = () => ({
  body: generateJoiValidation(Permissions.schema),
});

export const getPermissions = {
  query: Joi.object().keys({
    roleId: Joi.string().custom(objectId).optional(),
    companyType: Joi.string().optional(),
  }),
};
